import { WarningAmberRounded } from "@mui/icons-material";

import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

export default function FeeScheduleUnavailableState() {
  return (
    <div
      className="flex w-full flex-1 flex-row items-center justify-center gap-3 rounded-[12px] border px-4 py-3"
      style={{
        ...SETTLEMENT_STYLES.subtleBorder,
        backgroundColor: HNSColors.tertiary[900],
      }}
    >
      <WarningAmberRounded sx={SETTLEMENT_STYLES.warningIcon} />
      <span
        className="text-[14px] font-medium"
        style={{ color: HNSColors.primary[500] }}
      >
        Case needs a settled amount before the fee data is available
      </span>
    </div>
  );
}
